export default __webpack_public_path__ + "static/media/icon-ezfit.90396514.svg";